export enum PALockDataType {
  TIME_ATTENDANCE = "TIME_ATTENDANCE",
  OT = "OT",
  LEAVE = "LEAVE",
  PAYROLL = "PAYROLL",
}

export enum PALockDataAction {
  LOCK = "LOCK",
  UNLOCK = "UNLOCK",
}
